// Deployment configuration
// This file allows easy switching between local development and production environments

export const DEPLOYMENT_CONFIG = {
  // Backend API URLs
  BACKEND_URLS: {
    LOCAL: 'http://localhost:5000',
    PRODUCTION: 'https://api.intra-crm.com'
  },
  
  // Frontend URLs
  FRONTEND_URLS: {
    LOCAL: 'http://localhost:3000',
    PRODUCTION: 'https://crm-frontend-8u75.onrender.com',
    CUSTOM_DOMAIN: 'https://intra-crm.com'
  },
  
  // MEO Portal URL (real portal, not proxy)
  MEO_PORTAL_URL: 'https://portal.meo.pt',
  
  // Environment detection
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Get current backend URL based on environment
  getBackendUrl: () => {
    return process.env.NODE_ENV === 'development' 
      ? DEPLOYMENT_CONFIG.BACKEND_URLS.LOCAL
      : DEPLOYMENT_CONFIG.BACKEND_URLS.PRODUCTION;
  },
  
  // Get current frontend URL based on environment
  getFrontendUrl: () => {
    if (process.env.NODE_ENV === 'development') {
      return DEPLOYMENT_CONFIG.FRONTEND_URLS.LOCAL;
    }
    
    // Check if we're running on the custom domain
    if (typeof window !== 'undefined' && 
        (window.location.hostname === 'intra-crm.com' || window.location.hostname === 'www.intra-crm.com')) {
      return DEPLOYMENT_CONFIG.FRONTEND_URLS.CUSTOM_DOMAIN;
    }
    
    return DEPLOYMENT_CONFIG.FRONTEND_URLS.PRODUCTION;
  }
};

// Export for easy access
export default DEPLOYMENT_CONFIG; 